import { GeneralModel } from "./general.model";

export class Role extends GeneralModel {
    parrentRoleId:number;
    parrentRole: Role;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/role.model.ts